const LABELS = {
  WHATSAPP: 'WhatsApp', INSTAGRAM: 'Instagram', FACEBOOK: 'Facebook', GOOGLE: 'Google', EMAIL: 'e-mail',
  PHONE: 'phone', IN_PERSON: 'in person', OTHER: 'shared with us',
};

/** "Verified buyer" for buyers on this site; otherwise where the customer gave the review, e.g. "via WhatsApp". */
export const sourceText = (review) => {
  if (review?.verifiedPurchase) return 'Verified buyer';
  if (!review?.source || review.source === 'STOREFRONT') return 'Customer review';
  return review.source === 'OTHER' ? 'Shared with us' : `via ${LABELS[review.source] || review.source}`;
};
